<template>
    <router-link
        class="cell article-block"
        :to="{ name: 'activity_detail', params: { activity_id: product.id, campaign }, query: formattedQuery }">
        <figure
            class="article-block__figure"
            :style="`background-image: url(${image});`">
            <img
                :src="image"
                :alt="product.title">
        </figure>

        <div class="label-pusher">
            <activity-label :type="product.type" />
        </div>

        <div class="article-block__content">

            <h2 class="h4 article-block__title">{{ product.title }}</h2>

            <div class="article-block__bottom">
                <div
                    class="article-block__location"
                    v-if="product.provider">
                    {{ product.provider.name }}
                    <span class="dot">&nbsp;</span>
                    {{ product.location.city }}
                </div>

                <figure
                    class="acticle-block__logo"
                    v-if="product.location && product.location.images.thumbnail">
                    <img
                        :src="product.location.images.thumbnail"
                        alt="">
                </figure>
            </div>
        </div>
    </router-link>
</template>

<script>
import ActivityLabel from '@/components/Label.vue';
import { FallbackImage } from '@/helpers';

export default {
    components: {
        ActivityLabel,
    },
    props: {
        product: {
            type: Object,
            default() {
                return {}
            }
        },
        campaign: {
            type: String,
            default: undefined,
            required: false
        }
    },
    computed: {
        image() {
            if(!this.product.image['1240x1240']) {
                return FallbackImage(this.product.id);
            } else {
                return this.product.image['1240x1240'];
            }
        },
        formattedQuery() {
            if(this.$store.state.products.filters.date && !this.$store.state.products.noresults) {
                return { datum: this.$store.state.products.filters.date };
            }

            return {};
        }
    }
};
</script>
